<template>
  <div class="h-100 d-flex flex-column align-end justify-space-around">
    <ConnectingLine
      :startElementId="`system-${system.index}`"
      :endElementId="`event-${system.index}-${event.index}`"
      :refreshKey="refreshKey"
      direction="auto"
      offsetParentId="domain-model"
    />
    <div
      :id="`event-${system.index}-${event.index}`"
      class="event-card-container ma-1"
      style="max-width: 100px; max-height: 90px;"
    >
      <svg width="104" height="80">
        <bpmn-event
          :svgGraph="svgGraph"
          :svgLanes="svgLanes"
          :svgGroups="svgGroups"
          :workflow="workflow"
          :eventDefinition="workflow.eventDefinition"
          :node="{ ...event, x: 0, y: 0, withoutActions: true, svgMaskPrefix: `aggregation-view` }"
          class="bpmn-event-container"
        />
      </svg>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import safeStructuredClone from '@/utils/clone'
import BpmnEvent from '@/components/BpmnEvent.vue'
import ConnectingLine from '@/components/ConnectingLine.vue'

const { system, event, refreshKey } = defineProps({ system: Object, event: Object, refreshKey: Number })

const store = useStore()
const workflow = computed(() => store.state.workflow.workflow)
const svgGraph = computed(() => safeStructuredClone(store.getters['svgGraphData/svgGraphData']))
const svgLanes = computed(() => safeStructuredClone(store.getters['svgGraphData/svgLanesData']))
const svgGroups = computed(() => safeStructuredClone(store.getters['svgGraphData/svgGroupsData']))
</script>

<style scoped>
.event-card-container {
  svg {
    border-radius: 4px;
    vertical-align: middle;
    filter: url(#shadow-event-hover);
  }

  :deep(.draggable) {
    cursor: text !important;
  }
}
</style>
